module.exports = __webpack_public_path__ + "static/media/dental-implant.7cbe9343.svg";